import FeedbackSurvey from "@/components/FeedbackSurvey";
import FeedbackIcon from "@/components/Icons/feedback.svg";

const DeliveryFeedbackCTA: React.FC = () => (
  <div className="container flex bg-green-20 justify-center py-lg px-md rounded">
    <div className="max-w-[488px] w-full">
      <div className="flex justify-center" data-testid="feedback-icon">
        <FeedbackIcon />
      </div>
      <div className="self-center text-center text-sm mt-sm font-bold">
        We’re building a better delivery experience - help us improve.
      </div>
      <div className="mt-lg flex justify-center" data-testid="feedback-survey">
        <FeedbackSurvey
          surveyId="jAU3zvrF"
          className="button button--secondary bg-white"
          linkText="share your thoughts"
        />
      </div>
    </div>
  </div>
);

export default DeliveryFeedbackCTA;
